<base-site-layout
  [heading]="'Freigabedetails' | translate"
  headerIcon="fas fa-eye"
  [isDialog]="true"
  (dialogCloseClicked)="close()"
  >
@for (group of approvalInfo.groups; track group) {
  <div class="row mb-1">
    <div class="col">
      <iim-card [header]="header">
        <ng-template #header>
          <div class="row align-items-center">
            <div class="col">
              {{ group.name }}
            </div>
            <div class="col-auto">
              <span class="text-description font-09">
                {{ 'Freigaben erforderlich: {{count}} ' | translate: { count: group.approvalsNeeded } }}
              </span>
            </div>
          </div>
        </ng-template>
        <ul class="list-group">
          @for (approver of group.possibleApprovers; track approver) {
            <li class="list-group-item">
              <div class="px-3">
                <div class="row align-items-center">
                  <div class="col">
                    {{ approver.approver | person }}
                  </div>
                  <div class="col-auto"
                                     [ngClass]="{
                                        'text-success': approver.approvalStatus === ApprovalStatus.APPROVED,
                                        'text-secondary': approver.approvalStatus === ApprovalStatus.PENDING,
                                        'text-danger': approver.approvalStatus === ApprovalStatus.REJECTED
                                     }">
                    <div class="row justify-content-end">
                      <div class="col-auto">
                        @if (!approver.isPending) {
                          <em class="fas"
                                               [ngClass]="{
                                                    'fa-check-circle': approver.approvalStatus === ApprovalStatus.APPROVED,
                                                    'fa-times-circle': approver.approvalStatus === ApprovalStatus.REJECTED
                                               }"></em>
                        }
                        @if (approver.isPending && group.isPending) {
                          <span>
                            {{ 'ausstehend' | translate }}
                          </span>
                        }
                        @if (approver.approvalStatus === ApprovalStatus.APPROVED) {
                          <span>
                            {{ 'freigegeben' | translate }}
                          </span>
                        }
                        @if (approver.approvalStatus === ApprovalStatus.REJECTED) {
                          <span>
                            {{ 'abgelehnt' | translate }}
                          </span>
                        }
                      </div>
                    </div>
                    @if (approver.approvedTimestamp && !approver.isPending) {
                      <div class="row justify-content-end">
                        <div class="col-auto">
                          <span class="text-description font-08">
                            {{ approver.approvedTimestamp | dayjs: 'lll' }}
                          </span>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </li>
          }
        </ul>
      </iim-card>
    </div>
  </div>
}
<div class="row my-2 justify-content-end">
  <div class="col-auto">
    <button class="btn btn-sm btn-outline-dark" (click)="close()">{{ 'schließen' | translate }}</button>
  </div>
</div>
</base-site-layout>
